import { create } from 'zustand'
import type { OfflineSessionData } from '@/lib/offline-session'

interface OfflineSessionState {
  isOfflineSession: boolean
  session: OfflineSessionData | null
  setSession: (session: OfflineSessionData) => void
  clearSession: () => void
}

export const useOfflineSessionStore = create<OfflineSessionState>((set) => ({
  isOfflineSession: false,
  session: null,
  setSession: (session) => set({ isOfflineSession: true, session }),
  clearSession: () => set({ isOfflineSession: false, session: null }),
}))
